export default __webpack_public_path__ + "6614a1f2387833dcfe229fb1b3914714.png";